import React, {useEffect, useState, useRef} from 'react';
import styled from 'styled-components';
import {useSelector} from '../../shared-services/redux-tiny';
import {currentTheme} from '../../react-themes/theme';
import {t} from '../../shared-services/translate';
import {mediaQuery} from '../../react-components/shared/GlobalStyles';

const theme = currentTheme();
const smallestWidthDiscountFarmyFamily = 136;
const smallestWidthDiscount = 90;

// This listMode specific
// TODO: Move into a mode-specific item component
export const PriceTag = (props) => {
  const ref = useRef(null);
  const {product, layout} = props;
  const {eligible_for_ffamily: farmyFamilyEligible, price: value, strikeout_price: oldPrice, packaging} = product;
  const currentUser = useSelector(state => state.session.currentUser);
  const price = parseFloat(value).toFixed(2);
  const oldPriceFormatted = oldPrice ? parseFloat(oldPrice).toFixed(2) : null;

  const [canSeeFarmyFamilyPrice, setCanSeeFarmyFamilyPrice] = useState(true);
  const [farmyFamilyUser, setFarmyFamilyUser] = useState(currentUser?.ff_subscriber || false);
  const [currentPriceColor, setCurrentPriceColor] = useState(theme.colors.farmy.green);
  const [smallElement, setSmallElement] = useState(null);

  const getCurrentPriceColor = () => {
    if (!oldPrice || (!canSeeFarmyFamilyPrice && farmyFamilyEligible)) {
      layout === 'mobile_cards' ? setCurrentPriceColor(theme.colors.textColor) : setCurrentPriceColor(theme.colors.farmy.green);
    } else if (!canSeeFarmyFamilyPrice || !farmyFamilyEligible) {
      setCurrentPriceColor(theme.colors.farmy.orange);
    } else if (farmyFamilyUser) {
      setCurrentPriceColor(theme.colors.farmy.farmyFamilyBg);
    } else {
      layout === 'mobile_cards' ? setCurrentPriceColor(theme.colors.textColor) : setCurrentPriceColor(theme.colors.farmy.green);
    }
  };

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      if (entries[0]) {
        const width = entries[0].contentRect.width;
        const widthBenchmark = canSeeFarmyFamilyPrice && farmyFamilyEligible ? smallestWidthDiscountFarmyFamily : smallestWidthDiscount;
        if (layout === "list" && width && oldPrice && (width < widthBenchmark)) {
          setSmallElement(true);
        } else {
          setSmallElement(false);
        }
      }
    });

    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setFarmyFamilyUser(currentUser?.ff_subscriber);
  }, [currentUser]);

  useEffect(() => {
    getCurrentPriceColor();
  }, [canSeeFarmyFamilyPrice, oldPrice, farmyFamilyUser]);

  return <PriceTagElement
    ref={ref}
    className={`
      price-tag
      ${smallElement ? " flex-direction-column" : ""}
    `}
    farmyFamily={canSeeFarmyFamilyPrice && farmyFamilyEligible && oldPrice}>
    {canSeeFarmyFamilyPrice && farmyFamilyEligible && oldPrice &&
      <FarmyFamilyPrice
        className={`
          ${smallElement ? "justify-content-flex-end margin-right-0" : "justify-content-flex-start margin-right-5"}
        `}
        value={oldPriceFormatted}
        layout={layout}
      >
        <div className="farmy-family-title">
          {t("farmy_family.price")}
          {!farmyFamilyUser && ":"}
        </div>
        {!farmyFamilyUser && <StrikeoutPrice layout={layout}>
          <div className="farmy-family-price">
            <CurrencyCode className="cur-code">{window.defaultCurrency}</CurrencyCode>
            {price}
          </div>
        </StrikeoutPrice>}
      </FarmyFamilyPrice>
    }
    <PriceAndPackaging color={currentPriceColor}>
      <PriceBox className={smallElement ? "flex-direction-column" : null}>
        {oldPrice && (!farmyFamilyEligible || (farmyFamilyEligible && farmyFamilyUser)) &&
          <StrikeoutBlock>
            <StrikeoutPrice layout={layout}>
              <StrikeoutHr farmyFamily={canSeeFarmyFamilyPrice && farmyFamilyEligible} layout={layout}/>
              <CurrencyCode className="cur-code">{window.defaultCurrency}</CurrencyCode>
              <UsuallyAmount value={oldPriceFormatted} farmyFamily={canSeeFarmyFamilyPrice} layout={layout}>{oldPriceFormatted}</UsuallyAmount>
            </StrikeoutPrice>
          </StrikeoutBlock>
        }
        <CurrentPrice color={currentPriceColor} layout={layout}>
          <CurrencyCode className="cur-code">{window.defaultCurrency}</CurrencyCode>
          {canSeeFarmyFamilyPrice && <div>{farmyFamilyEligible && !farmyFamilyUser && oldPrice ? oldPriceFormatted : price}</div>}
          {!canSeeFarmyFamilyPrice && <div>{farmyFamilyEligible && oldPrice ? oldPriceFormatted : price}</div>}
        </CurrentPrice>
      </PriceBox>
      {packaging && <div className="packaging">{`/ ${packaging}`}</div>}
    </PriceAndPackaging>
  </PriceTagElement>
}

export default PriceTag;

const PriceTagElement = styled.span.attrs(props => ({
  style: {
    justifyContent: props.farmyFamily ? 'space-between' : 'flex-end'
  },
  className: `
    flex
    full-width
    ${props.farmyFamily ? 'justify-content-space-between' : 'justify-content-flex-end'}`
}))``;

const PriceAndPackaging = styled.div.attrs({
  className: `
    flex
    justify-content-flex-end
    align-items-center`
})`
  flex-wrap: wrap;
  .packaging {
    color: ${props => props.color};
    
    ${mediaQuery('sm')`
      display: none;
    `}
  }
`;

const StrikeoutBlock = styled.div.attrs({
  className: `
    margin-right-5`
})``;

const StrikeoutPrice = styled.div`
  color: ${theme.colors.farmy.lightgrey};
  font-weight: 400;
  display: inline-block;
  font-size: 80%;

  span {
    font-size: 60%;
    top: -6px;
  }
  @media (max-width: 375px) {
    font-size: ${props => props.layout === 'pdp' ? '80%' : '10px'};
    span {
      font-size: 60%;
      top: -6px;
    }
  }
`;

const StrikeoutHr = styled.hr.attrs(props => ({
  style: {
    borderColor: props.farmyFamily ? theme.colors.farmy.farmyFamilyBg : theme.colors.farmy.orange,
    margin: props.layout === 'pdp' ? '0px auto -13px 2%' : '0px auto -8px 2%'
  }
}))`
  padding: 0;
  width: 110%;
  border-width: 1px;
  transform: rotate(-13deg);
  -ms-transform: rotate(-13deg);
  -webkit-transform: rotate(-13deg);
  mix-blend-mode: multiply;
`;

const UsuallyAmount = styled.div`
  display: inline-block;
  @media (max-width: 420px) {
    font-size: ${props => props.layout === 'pdp' ? '14px' : props.value > 9.99 && props.farmyFamily ? '10px' : '11px'};
  }
`;

const CurrencyCode = styled.span`
  font-size: 75%;
  top: -3px;
  position: relative;
`;

const FarmyFamilyPrice = styled.span.attrs({
  className: `
    flex
    align-items-flex-start
  `
})`
  color: ${theme.colors.farmy.farmyFamilyBg};
  font-weight: 400;
  margin-top: 4px;
  .farmy-family-title {
    font-size: 80%;
    text-align: left;
    white-space: nowrap;
    @media (max-width: 420px) {
      font-size: ${props => props.layout === 'pdp' ? '80%' : props.value < 100 ? props.value < 10 ? '11px' : '9px' : '8px'};
    }
  }
  .farmy-family-price {
    color: ${theme.colors.farmy.farmyFamilyBg};
    margin-left: 3px;
  }
`;

const PriceBox = styled.span.attrs({
  className: `
    flex
    justify-content-flex-end
    align-items-center
  `
})``;

const CurrentPrice = styled.span.attrs(props => ({
  style: {
    color: props.color || theme.colors.farmy.green
  },
  className: `
    flex
    justify-content-flex-end
    align-items-center
  `
}))`
  margin-left: 5px;
  flex-wrap: wrap;
  @media (max-width: 420px) {
    margin-left: ${props => props.layout === 'pdp' ? '5px' : '1px'};
  }
`;
